import React, { useState } from "react"
import ReactInputMask from "react-input-mask"
import { CardTitle, Col, Input, Label, Row } from "reactstrap"
import PropTypes from "prop-types"

const Address = ({ dealerAddress }) => {
  return (
    <Row>
      <Row sm="7" >
      <h4 className="card-title mb-2 ">Dealer Address Details</h4>
        <Col md='4' className="mb-3">
          <Label htmlFor="horizontal-password-Input" className="col-sm-5 label-styling">
            Address
          </Label>
          <p>
            {dealerAddress?.[0]?.address1 || "-"
               + ", "+
              (dealerAddress?.[0]?.address2
                ? dealerAddress?.[0]?.address2
                : "") +
              "" +
              (dealerAddress?.[0]?.address3
                ? dealerAddress?.[0]?.address3
                : "")}
          </p>
        </Col>
        <Col md='4' className="mb-3" >
          <Label htmlFor="horizontal-password-Input" className="col-sm-5 label-styling ">
            City
          </Label>

          <p>{dealerAddress?.[0]?.city || "-"}</p>
        </Col>
        <Col md='4' className="mb-3">
          <Label htmlFor="horizontal-password-Input" className="col-sm-5 label-styling ">
            State
          </Label>

          <p>{dealerAddress?.[0]?.state || "-"}</p>
        </Col>
        <Col md='4' className="mb-3">
          <Label htmlFor="horizontal-password-Input" className="col-sm-5 label-styling ">
            Country
          </Label>

          <p>{dealerAddress?.[0]?.country || "-"}</p>
        </Col>
        <Col md='4' className="mb-3">
          <Label htmlFor="horizontal-password-Input" className="col-sm-5 label-styling">
            PinCode
          </Label>

          <p>{dealerAddress?.[0]?.pincode || "-"}</p>
        </Col>
      </Row>
    </Row>
  )
}

Address.propTypes = {
  formik: PropTypes.object,
}

export default Address
